














































import { Component, Prop, Vue } from 'vue-property-decorator'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { DashboardModule } from '@/app/store/modules/dashboard'

@Component({
  name: 'FilterChart',
  components: {
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  public selectDealerName: number = 0
  public selectedGroupName: number = 0
  public optionsDealerName: any = [
    { value: 0, text: '- Select Dealer Name -' },
    { value: 1, text: 'Dealer Name 1' },
  ]
  public optionsGroupName: any = [
    { value: 0, text: '- Select Dealer Group -' },
    { value: 1, text: 'Dealer Group 1' },
  ]
  public filterDate = []
  public refresh() {
    DashboardModule.getDashboardData()
  }
}
